import React from "react";
import Marquee from "react-fast-marquee";
import Footer from "../../Layout/Footer";
import "../../../App.css";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";

const Landing = () => {
  return (
    <div className="w-full">
      <div className="w-full">
        <div>
          <Section1 />
          <div className=" w-full overflow-hidden whitespace-nowrap bg-gradient-to-r from-[#F6FFE9] from-[10%] to-[#856E4F] to-[30%]   font-poppins text-sm py-1 ">
            <Marquee>
              <p className="marquee font-bold ">
              200+ Active Daily Users &nbsp;&nbsp;&nbsp; • $500M+ Processed in Transaction Volume&nbsp;&nbsp;&nbsp; • 99.9% Uptime for Reliable Transfers&nbsp;&nbsp;&nbsp; • 100+ Partnerships Worldwide • 
              </p>
            </Marquee>
          </div>
          <Section2 />
          <Section3 />
          <div id="collection">
          <Section4 />
          </div>
          <div id="faq">
          <Section5 />
          </div>
          <div id="about">
          <Section6 />
          </div>
          <Section7 />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Landing;
